import React, { FC } from 'react';
import { Box, Button, Divider, Popover, Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../hooks';

interface AccountPopoverProps {
  anchorEl: null | Element;
  onClose?: () => void;
  open?: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    divider: {
      margin: theme.spacing(0, 1.5)
    },
    textParent: {
      padding: theme.spacing(2)
    },
    buttonParent: {
      display: "flex",
      padding: theme.spacing(1),
      justifyContent: "center"
    }
  })
);

export const AccountPopover: FC<AccountPopoverProps> = (props) => {
  const { anchorEl, onClose, open = false } = props;

  const classes = useStyles();
  const { t } = useTranslation();

  const {user, isLoggedIn, logIn, logOut} = useAuth();

  const onLogin = () => {
    logIn();
  };

  const onLogout = () => {
    logOut();
  };

  return (
    <Popover
      anchorEl={anchorEl}
      anchorOrigin={{
        horizontal: 'right',
        vertical: 'bottom'
      }}
      disableScrollLock
      transformOrigin={{
        horizontal: 'right',
        vertical: 'top'
      }}
      onClose={onClose}
      open={open}
      PaperProps={{ style: { width: 200 } }}
    >

      {isLoggedIn && <React.Fragment>
        <Box className={classes.textParent}>
          {(user?.firstName || user?.lastName) &&
            <Typography variant="body1">
              {`${user.firstName} ${user.lastName}`}
            </Typography>
          }
          <Typography
            color="textSecondary"
            variant="body2"
          >
            {user ? user.email : ""}
          </Typography>
        </Box>

        <Divider className={classes.divider}/>

        <Box className={classes.buttonParent}>
          <Button
            color="secondary"
            onClick={onLogout}
            size="small"
          >
            {t("user-account.logout_from_engine_cloud")}
          </Button>
        </Box>
      </React.Fragment>}

      {!isLoggedIn && <React.Fragment>
        <Box className={classes.textParent}>
          <Typography variant="subtitle2">
            {"An linked Engine Cloud account is required to use certain features"}
          </Typography>
        </Box>

        <Divider className={classes.divider}/>

        <Box className={classes.buttonParent}>
          <Button
            color="inherit"
            onClick={onLogin}
            size="small"
          >
            {t("user-account.link_engine_cloud_account")}
          </Button>
        </Box>
      </React.Fragment>}

    </Popover>
  );
};
